import React, {Component} from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {Backdrop, Block, Overlay, Portal} from "reakit";
import {Box, Flex, Heading, Image, Text} from 'rebass';
import IosArrowBack from 'react-ionicons/lib/IosArrowBack'

import {HeaderWrapper} from "../Base/MobileHeader";
import {ProfileCard} from "../../components/Cards";
import chevronRight from "../../resources/img/icons/Chevron_2@1x.png";

const FilterOverlay = styled(Overlay)`
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
		width: 50%;
 		height: 80%;
 @media(max-width: 700px){
 		width: 100%;
		height: 100%;
 }
`

export const HorizontalScroll = styled(Flex)`
  display: flex; /* [1] */
  flex-wrap: nowrap; /* [1] */
  overflow-y: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  ::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
`;

class MobileProfile extends Component {

	state = {
		gender: '',
		grade: '',
		dorm: '',
		location: '',
		type: ''
	};

	handleSelect = () => {
		console.log('select')
	};

	render() {
		const {profile} = this.props;
		return (
			<Overlay.Container>
				{overlay => (
					<Block overflowY={'auto'}>
						<Flex onClick={overlay.show} {...overlay}>
							<Box><Text fontWeight={600}>{profile && profile.first_name}'s Profile</Text></Box>
							<Box mr={'auto'}/>
							<Box><Image src={chevronRight}/> </Box>
						</Flex>
						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay} margin={0} padding={0}>
							{overlay.visible &&
							<Box>
								<HeaderWrapper boxShadow={'main'} pt={2} px={2} width={1}>
								<Box mt={2}>
								<IosArrowBack fontSize={'30px'} onClick={overlay.hide}/>
								</Box>
								<Heading pb={'19px'} pl={'6px'}>{profile.first_name}'s Profile</Heading>
								</HeaderWrapper>
								<Box>
									<Flex flexWrap={'wrap'} p={1} mt={1}>
										<ProfileCard profile={profile}/>
									</Flex>
								</Box>
							</Box>}
						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}

MobileProfile.propTypes = {
	profile: PropTypes.object
};

MobileProfile.defaultProps = {
	profile: {first_name: '', last_name: ''}
};


export default MobileProfile
